/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as creator_contact from "./creator_contact";
export { creator_contact };
export var int32 = {
  ALL: 0,
  PENDING: 1,
  READY_TO_SHIP: 2,
  SHIPPED: 3,
  CONTENT_PENDING: 4,
  COMPLETED: 5,
  CANCELLED: 6
};
export var DeliveryType = {
  LIVE: 1,
  VIDEO: 2
};
export var AuditType = {
  APPROVE: 1,
  REJECT: 2,
  COMPLETE: 3,
  DELETE: 4
};
export var ApplyActionSource = {
  AFFILIATE_SAMPLE: 1,
  IM_CARD: 2
};
export var SearchKey = {
  INVALID: 0,
  CREATOR_NAME: 1,
  CREATOR_ID: 2,
  PRODUCT_NAME: 3,
  PRODUCT_ID: 4,
  CREATOR_FOLLOWERS: 5,
  PACKAGE_ID: 6,
  COLLECTION_METHOD: 7,
  CREATOR_LABEL: 8,
  MAIN_ORDER_ID: 9,
  CREATOR_AGENCY: 10,
  CREATOR_MAIN_CATEGORY: 11,
  CREATOR_FOLLOWER_GENDER: 12,
  CREATOR_FOLLOWER_AGE: 13,
  CREATOR_CONTENT_TYPE: 14,
  CREATOR_COOPERATED_WITH_BEFORE: 15,
  CREATOR_REJECTED_BEFORE: 16,
  CREATOR_GMV_RANGE: 17,
  CREATOR_GPM_RANGE: 18,
  CREATOR_AVG_VIDEO_VIEWS: 19,
  CREATOR_AVG_LIVE_VIEWS: 20,
  CREATOR_RELIABLE_WITH_SAMPLES: 21,
  SOON_TO_EXPIRE: 22,
  TARGET_INVITATION_GROUP_ID: 23,
  SOURCE_TYPE: 24,
  SAMPLE_FULFILLMENT_RANK: 51,
  IS_GROI: 60
};
export var SourceType = {
  OPEN_COLLABORATION: 0,
  TARGET_COLLABORATION: 1,
  AGENCY_CAMPAIGN_APPLY_BY_AGENCY: 3,
  GROI: 4,
  SOURCE_TYPE_ALL: 100
};
export var SearchType = {
  KEYWORD: 1,
  WILDCARD: 2,
  RANGE: 3,
  IN: 4,
  BOOL: 5
};
export var Gender = {
  GENDER_ALL: 0,
  MALE: 1,
  FEMALE: 2
};
export var PageMode = {
  BY_PAGE: 1,
  BY_OFFSET: 2,
  BY_CURSOR: 3
};
export var OrderKey = {
  FOLLOWER_NUM: 1,
  CREATOR_GMV: 2,
  CREATOR_CONTENT_COUNT: 3,
  CREATOR_FULFILLMENT_RATE: 4,
  CREATOR_AVG_EC_VIDEO_VIEWS_30_DAY: 5
};
export var GROIPerfOrderKey = {
  ESTIMATED_ROI: 1,
  ACTUAL_ROI: 2,
  SHIPPED_SAMPLE_CNT: 3,
  SAMPLE_COST: 4,
  PRODUCT_SOLD_CNT: 5,
  PRODUCT_GMV: 6
};
export var OrderType = {
  DEFAULT: 0,
  ASC: 1,
  DESC: 2
};
export var ShipmentServiceType = {
  SELLER_FULFILLMENT: 1,
  PLATFORM_SHIPMENT: 2
};
export var ShipmentServiceStatus = {
  AVAILABLE: 1,
  BLOCK_BY_MULTI_PACKAGE: 2,
  NOT_SUPPORT: 3,
  SELLER_IN_BLOCK_LIST: 4,
  PLATFORM_SERVICE_CONFLICT: 5,
  ALREADY_SELECTED_SHIPMENT_METHOD: 6
};
export var CollectionMethod = {
  PICK_UP: 1,
  DROP_OFF: 2,
  VAN_COLLECTION: 4
};
export var GroupIDType = {
  GROUP_CREATOR_ID: 1,
  GROUP_TRACKING_NUMBER: 2,
  GROUP_PACKAGE_ID: 3
};
export var CreateShipResultType = {
  ALL_SUCCESS: 1,
  PART_SUCCESS: 2,
  ALL_FAILED: 3
};
export var DocContentType = {
  SHIPPING_LABEL: 1,
  PICKING_LIST: 2
};
export var DocTemplateType = {
  A6: 0,
  A5: 1
};
export var FreeSampleRuleStatus = {
  FREE_SAMPLE_ENABLED: 1,
  PLAN_EXCEPTION: 2,
  FREE_SAMPLE_NO_LEFT_COUNT: 3,
  FREE_SAMPLE_EXPIRED: 4,
  FREE_SAMPLE_NOT_CREATED: 5,
  FREE_SAMPLE_NOT_STARTED: 6
};
export var FreeSampleRuleThresholdType = {
  FOLLOWER_COUNT: 1,
  GMV: 2,
  CONTENT_COUNT: 3,
  AVG_EC_VIDEO_VIEWS_30_DAY: 4,
  MAIN_CATEGORY_IDS: 5,
  FULFILLMENT_RANK: 6,
  PREDICT_FULFILLMENT_RANK: 7
};
export var SampleFulfillmentStatus = {
  IN_PROGRESS: 1,
  SUSPENDED: 2,
  EXEMPTED: 3
};
export var SampleActionErrorCode = {
  CreatorLimit: 16022001,
  ShopLimit: 16022002,
  SkuOutOfStock: 16022003,
  SkuStatusInvalid: 16022004,
  SkuNoWarehouse: 16022005,
  AddressUnreachable: 16022006,
  PlanInvalid: 16022007,
  SampleOutOfStock: 16022008,
  SampleRuleInvalid: 16022009,
  UnableCreateSampleOrder: 16022010,
  SampleOrderLimit: 16022011,
  ProductUndeliverable: 16022012
};
export var PromoteSelectionType = {
  SPECIFIC_PRODUCT_ID: 1,
  SPECIFIC_CATEGORY_ID: 2,
  ALL_UNPROMOTED: 3,
  ALL_PROMOTED: 4
};
export var ProcessStatus = {
  IN_PROCESS: 1,
  FINISHED: 2
};
export var PromoteFailedReason = {
  NO_SPECIFIC: 0,
  PRODUCT_UNAVAILABLE: 1,
  STOCK_INSUFFICIENT: 2
};
export var SampleRuleEditAction = {
  ACTIVATE: 0,
  DEACTIVATE: 1
};
export var ImFuncStatus = {
  NORMAL: 0,
  CREATOR_NOT_AUTHORIZED_TO_EU_CB_SELLER: 1
};
export var RefundableTabType = {
  REFUNDABLE_TAB_TYPE_ALL: 0,
  REFUNDABLE_TAB_TYPE_RTS: 1,
  REFUNDABLE_TAB_TYPE_SHIPPED: 2,
  REFUNDABLE_TAB_TYPE_PENDING_CRITERIA: 3,
  REFUNDABLE_TAB_TYPE_REFUNDED: 4,
  REFUNDABLE_TAB_TYPE_NOT_REFUND: 5,
  REFUNDABLE_TAB_TYPE_CANCELED: 6
};
export var RefundableSampleApplyStatus = {
  REFUNDABLE_APPLY_STATUS_RTS: 20,
  REFUNDABLE_APPLY_STATUS_SHIPPED: 30,
  REFUNDABLE_APPLY_STATUS_PENDING_CRITERIA: 40,
  REFUNDABLE_APPLY_STATUS_UNFULFILLED_CANCELLED: 53,
  REFUNDABLE_APPLY_STATUS_SELLER_NOT_SHIP_CANCELLED: 55,
  REFUNDABLE_APPLY_STATUS_UNFULFILLABLE_CANCELLED: 57,
  REFUNDABLE_APPLY_STATUS_REVERSE_CANCELLED: 58,
  REFUNDABLE_APPLY_STATUS_MEET_CRITERIA: 100,
  REFUNDABLE_APPLY_STATUS_REFUND_START: 300,
  REFUNDABLE_APPLY_STATUS_REFUND_SUCCESS: 301,
  REFUNDABLE_APPLY_STATUS_REFUND_FAILED: 302
};
export var SampleOrderType = {
  UnSpecifiedSampleOrderType: 0,
  PLATFORM_ACTIVITY: 1,
  SampleScoreActivity: 2,
  PlatformFreeSample: 3,
  OpenSampleApplyByCreator: 10,
  TargetSampleApplyByCreator: 11,
  AgencyCampaignSampleApplyByAgency: 12,
  OperatorInviteApplyByCreator: 13,
  SellerCrsCampaignApplyByAgency: 14,
  GroiOpenSampleApplyByCreator: 15,
  PlatformAgencyCampaignApplyByCreator: 16,
  RefundableSample: 17,
  AgencyCampaignSampleApplyByCreator: 18,
  SellerCrsCampaignApplyByCreator: 19,
  GsOpenPlacementSampleApplyByCreator: 100,
  GsAgencyCampaignSampleApplyByAgency: 101,
  GsAgencyCampaignSampleApplyByCreator: 102,
  SampleCoupon: 200
};
export var SellerOpenFreeSampleRuleType = {
  OPEN_THRESHOLD_RULE: 1,
  GROI_RULE: 2,
  REFUNDABLE_RULE: 3
};
export var GROIFreeSampleIneligibleCode = {
  UNAUTHORIZED_INELIGIBLE: 0,
  IMAGES_INELIGIBLE: 1,
  DESCRIPTION_INELIGIBLE: 2,
  SELLER_TIER_INELIGIBLE: 3,
  DELV_SPEED_INELIGIBLE: 4,
  INVENTORY_DAYS_OF_COVER_INELIGIBLE: 5,
  COMMISSION_RATE_INELIGIBLE: 6,
  OPEN_PLAN_CREATOR_APPROVE_INELIGIBLE: 7,
  OPEN_PLAN_INELIGIBLE: 8,
  PRODUCT_STATUS_INELIGIBLE: 9,
  GNE_LATE_DISPATCH_RATE_INELIGIBLE: 100,
  GNE_CANCELLATION_RATE_INELIGIBLE: 101,
  GNE_NEGATIVE_REVIEW_RATE_INELIGIBLE: 102
};